module.exports = __webpack_public_path__ + "media/images/canva-3bf68454181c103359ffd6cbb61fb3e1.svg";